import { CalculatorPages } from '../types';

export const pagesNamesByOrder: Record<string, CalculatorPages> = {
  1: CalculatorPages.financeDetails,
  2: CalculatorPages.applicantDetails,
  3: CalculatorPages.outgoings,
  4: CalculatorPages.reviewAnswers,
  5: CalculatorPages.results,
};

export const getFormKeyBySectionName = (sectionName: CalculatorPages) => {
  switch (sectionName) {
    case CalculatorPages.financeDetails:
      return 'financeDetails';
    case CalculatorPages.applicantDetails:
      return 'applicants';
    case CalculatorPages.outgoings:
      return 'outgoings';
    default:
      return null;
  }
};
